import { v, type Infer } from "convex/values";
import { recordTotalFromSaturation, type RecordTotal } from "./record-total";

export const boundedCountValidator = v.object({
  count: v.number(),
  isCapped: v.boolean(),
});

export type BoundedCount = Infer<typeof boundedCountValidator>;

export function boundedCountFromProbe(
  probe: ReadonlyArray<unknown>,
  cap: number,
): BoundedCount {
  return { count: Math.min(probe.length, cap), isCapped: probe.length > cap };
}

export function sumBoundedCounts(counts: ReadonlyArray<BoundedCount>): BoundedCount {
  return {
    count: counts.reduce((total, part) => total + part.count, 0),
    isCapped: counts.some((part) => part.isCapped),
  };
}

export function formatCappedCount(count: number, isCapped: boolean | undefined): string {
  const formatted = count.toLocaleString();
  return isCapped ? `${formatted}+` : formatted;
}

export function recordTotalFromBoundedCount(total: BoundedCount): RecordTotal {
  return recordTotalFromSaturation({ matched: total.count, saturated: total.isCapped });
}
